import { createApp } from 'vue'
import App from './App.vue'
import './index.css'

import "vue-skeletor/dist/vue-skeletor.css";
createApp(App).mount('#app')
